const StandardButton = ({children, ...props}) => {
    const cName = props.btnclass;

    return (
        <div className="btn-div cta-buttons _c001-cta-buttons">
            <a href={props.location} className={cName} target="_blank" rel="noreferrer">
                <label>{children}</label>&nbsp;<i className="cta-icon"></i>
            </a>
        </div>
    );
}

export default StandardButton;